import * as CONFIG from './config';


exports.getTeamList = function (id) {
    // console.log("getTeamList==>", id);
    return new Promise((resolve, reject) => {
        //resolve('{"CommitteeList": [{"id": 10,"name": "Training Team - 1","status": "active"},{"id": 11,"name": "BAHRAIN NATIONAL INSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 12,"name": "BAHRAIN NATIONAL LIFE ASSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 13,"name": "BAHRAIN NATIONAL HOLDING BOARD OF DIRECTORS","status": "active"},{"id": 14,"name": "BNL Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 15,"name": "BNI Executive & Investment Committee (EIC)","status": "active"},{"id": 16,"name": "BNH Executive & Investment Committee (EIC)","status": "active"},{"id": 17,"name": "BNI Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 18,"name": "BNH Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 19,"name": "BNH Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 20,"name": "BNI Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 21,"name": "BNL Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 22,"name": "Alpha Meeting Attendee","status": "active"},{"id": 23,"name": "Alpha Meeting Committee Adminstrator","status": "active"},{"id": 24,"name": "Training team2","status": "active"},{"id": 25,"name": "chat team","status": "active"},{"id": 26,"name": "test1team","status": "active"},{"id": 27,"name": "Mobile Team","status": "active"}]}');
        let param = '';
        if (id && id.length > 0)
            param = '/getCommittee/' + id;
        return CONFIG.httpGet('/Committee' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addTeam = function (objModel) {
    // console.log("addTeam==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/Committee', objModel)
            .then(function (response) {
                // console.log('addTeam succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addTeam err==>',err);
                reject(err);
            });
    });
}

exports.updateTeam = function (objModel) {
    // console.log("updateTeam==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPut('/committee', objModel)
            .then(function (response) {
                // console.log('addTeam succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addTeam err==>',err);
                reject(err);
            });
    });
}

exports.deleteTeam = function (objModel) {
    // console.log("deleteTeam==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/committee/delete/' + objModel)
            .then(function (response) {
                // console.log('deleteTeam succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteTeam err==>',err);
                reject(err);
            });
    });
}

exports.loadswitchercommittees = function () {
    // console.log("getTeamList==>");
    return new Promise((resolve, reject) => {
        //resolve('{"CommitteeList": [{"id": 10,"name": "Training Team - 1","status": "active"},{"id": 11,"name": "BAHRAIN NATIONAL INSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 12,"name": "BAHRAIN NATIONAL LIFE ASSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 13,"name": "BAHRAIN NATIONAL HOLDING BOARD OF DIRECTORS","status": "active"},{"id": 14,"name": "BNL Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 15,"name": "BNI Executive & Investment Committee (EIC)","status": "active"},{"id": 16,"name": "BNH Executive & Investment Committee (EIC)","status": "active"},{"id": 17,"name": "BNI Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 18,"name": "BNH Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 19,"name": "BNH Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 20,"name": "BNI Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 21,"name": "BNL Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 22,"name": "Alpha Meeting Attendee","status": "active"},{"id": 23,"name": "Alpha Meeting Committee Adminstrator","status": "active"},{"id": 24,"name": "Training team2","status": "active"},{"id": 25,"name": "chat team","status": "active"},{"id": 26,"name": "test1team","status": "active"},{"id": 27,"name": "Mobile Team","status": "active"}]}');
        return CONFIG.httpGet('/Committee/loadswitchercommittees')
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getTeamUserList = function (id) {
    // console.log("getTeamUserList==>", id);
    return new Promise((resolve, reject) => {
        let param = '';

        console.log('get team users ', id)

        // if (id!=null && id!=undefined && String(id).length > 0) {
        if (id && String(id).length > 0)
            console.log('get team users222 ', id)
        param = '/' + id;
        return CONFIG.httpGet('/smeeting/mUserList' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
        // }
    });
}

exports.getCustomerUserList = function () {
    // console.log("getTeamUserList==>", id);
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/esignature/customerList')
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}


// WEBPACK FOOTER //
// ./api/teamdetails.js